const SignInSuccessful = () => {
  return (
    <div>Sign in successful! Closing the popup...</div>
  );
}

export default SignInSuccessful
